module.exports = __webpack_public_path__ + "assets/img/wsj.3d8e63e7.png";